function ContactForm() {
  return (
    <form
      action=""
      className="flex flex-col items-start justify-start gap-4 p-6 rounded-xl bg-gray-100"
    >
      <h5 className="text-2xl color-green">
        Porozmawiajmy o Twoich potrzebach
      </h5>
      <input
        type="text"
        className="bg-white rounded-xl p-2 text-gray-600 w-full"
        placeholder="Adres e-mail"
      />
      <input
        type="text"
        className="bg-white rounded-xl p-2 text-gray-600 w-full"
        placeholder="Numer telefonu"
      />
      <input
        type="text"
        className="bg-white rounded-xl p-2 text-gray-600 w-full"
        placeholder="Temat rozmowy"
      />
      <div className="flex flex-row items-start justify-start gap-1">
        <input type="checkbox" name="" id="gdpr" className="mt-1" />
        <label htmlFor="gdpr" className="text-sm text-gray-600 text-left">
          Wyrażam zgodę na przetwarzanie moich danych osobowych celem realizacji
          zapytania. Oświadczam, że zapoznałem/am się z Regulaminem Serwisu,
          Obowiązkiem Informacyjnym oraz Polityką Prywatności i akceptuję
          postanowienia niniejszych dokumentów.
        </label>
      </div>
      <button className="button-green w-full mt-2">Wyślij</button>
    </form>
  );
}

export default ContactForm;
